import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setUnidentifiedOperatorsOperation = (state, { unidentifiedOperatorsData }) => {
  if (!unidentifiedOperatorsData) return state;
  return state.merge({ unidentifiedOperatorsData });
};

const setUnidentifiedOperatorsOperationLoaderStatus = (state, { unidentifiedOperatorsOperationLoader }) => {
  return state.merge({ unidentifiedOperatorsOperationLoader });
};

const setTrackerExist = (state, { trackerExistsData }) => {
  if (!trackerExistsData) return state;
  return state.merge({ trackerExistsData });
};

const setTrackerExistLoaderStatus = (state, { trackerExistLoader }) => {
  return state.merge({ trackerExistLoader });
};

const setOperatorById = (state, { operatorData }) => {
  if (!operatorData) return state;
  return state.merge({ operatorData });
};

const setOperatorByIdLoaderStatus = (state, { operatorByIdLoader }) => {
  return state.merge({ operatorByIdLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_UNIDENTIFIED_OPERATORS_OPERATION,
    actionFunction: setUnidentifiedOperatorsOperation,
  },
  {
    actionType: ActionTypes.SET_UNIDENTIFIED_OPERATORS_OPERATION_LOADER_STATUS,
    actionFunction: setUnidentifiedOperatorsOperationLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_TRACKER_EXIST_OPERATION,
    actionFunction: setTrackerExist,
  },
  {
    actionType: ActionTypes.SET_TRACKER_EXIST_OPERATION_LOADER_STATUS,
    actionFunction: setTrackerExistLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_OPERATOR_BY_ID,
    actionFunction: setOperatorById,
  },
  {
    actionType: ActionTypes.SET_OPERATOR_BY_ID_LOADER_STATUS,
    actionFunction: setOperatorByIdLoaderStatus,
  },
];
